var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wineclub-container container" }, [
    _c(
      "section",
      { staticClass: "club-section" },
      [_c("ClubContainer", { attrs: { club: _vm.club, single: "" } })],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }